import { PropsWithChildren } from 'react';
import ReactDOM from 'react-dom';
import { useDialog } from '../dialog.context';

type PortalProps = {
  containerId?: string;
};

export const Portal = ({
  children,
  containerId,
}: PropsWithChildren<PortalProps>) => {
  const { open } = useDialog();

  if (!open) {
    return null;
  }

  const portalContainer = containerId
    ? document.getElementById(containerId) ?? document.body
    : document.body;

  return ReactDOM.createPortal(children, portalContainer);
};

Portal.displayName = 'Dialog.Portal';
